import styles from './KnmPreview.module.scss';
import { IEpguNotification } from '../../../APIPackage/KnmSearchModule/interfaces/IEpguNotification';
import { KnmSubtitle } from './KnmSubtitle';
import { formatDateLocale } from '../../../CorePackage/MainModule/common/formatDate';
import { convertArrayToDate } from '../common/convertArrayToDate';
import {
  DATE_FORMAT_LONG_FNS,
  SYSTEM_DATE_FORMAT_SHORT_FNS,
} from '../../../CorePackage/MainModule/constants/dateFormats';

interface IEpguNotificationsProps {
  epguNotifications: IEpguNotification[] | undefined;
}

export const EpguNotifications = ({ epguNotifications }: IEpguNotificationsProps) => {
  const epguNotificationsGuids =
    epguNotifications
      ?.filter(item => !!item.subjectGuid)
      .map(item => item.subjectGuid)
      .filter((item, index, values) => values.indexOf(item) === index) || [];

  if (epguNotificationsGuids.length === 0) {
    return null;
  }

  return (
    <KnmSubtitle title="Сведения об информировании контролируемого лица в портал Госуслуги">
      {epguNotificationsGuids.map((subjectGuid, guidIndex) => (
        <div key={guidIndex}>
          <div className={styles.SectionTitle}>Контролируемое лицо #{guidIndex + 1}</div>
          {epguNotifications
            ?.filter(item => item.subjectGuid === subjectGuid)
            .map((item, index) => (
              <div key={index}>
                <div className={styles.SectionTitle}>Уведомление #{index + 1}</div>
                {item.eventName && (
                  <div className={styles.Row}>
                    <div className={styles.ColText}>Событие</div>
                    <div className={styles.ColValue}>{item.eventName}</div>
                  </div>
                )}
                {item.epguSendDate && (
                  <div className={styles.Row}>
                    <div className={styles.ColText}>Дата передачи данных в ЕПГУ</div>
                    <div className={styles.ColValue}>
                      {formatDateLocale({
                        date: convertArrayToDate(item.epguSendDate),
                        dateFormat: DATE_FORMAT_LONG_FNS,
                        parseFormat: SYSTEM_DATE_FORMAT_SHORT_FNS,
                      })}
                    </div>
                  </div>
                )}
              </div>
            ))}
        </div>
      ))}
    </KnmSubtitle>
  );
};
